import styles from 'styles/components/pages/chart/PeriodNotice.module.scss';

type Tprops = {
  date: string;
};

const PeriodNotice = ({ date }: Tprops) => {
  return (
    <div className="flex flex_column" style={{ marginTop: '72px' }}>
      <p className={styles.text}>차트 제출 기한은</p>
      <p className={styles.text}>
        <span className={styles.text_red}>{date} </span>
        <span>까지 입니다.</span>
      </p>
    </div>
  );
};

export default PeriodNotice;
